import React from 'react'

import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import PropTypes from 'prop-types'
import { Box, Card, CardActionArea, Typography } from '@material-ui/core'

import { routes } from 'SupplierRoutes'
import constants from 'constants/index'
import helpers from 'helpers'
import useAuthSupplier from 'hooks/useAuthSupplier'
import theme from 'theme'
import useStyles from './styles'

const QuestionCard = ({
  companySupplierQuestionnaireId,
  quizQuestionTemplate,
}) => {
  const { PROGRESS_STATUS_COLOR, PROGRESS_STATUS_ICON } =
    constants.suppliers.companySuppliers

  const { companySupplier } = useAuthSupplier()

  const answerStatus =
    helpers.suppliers.companySuppliers.quizQuestionTemplateStatus(
      quizQuestionTemplate,
      companySupplier,
    )

  const color = PROGRESS_STATUS_COLOR[answerStatus]

  const classes = useStyles(color)()
  const history = useHistory()

  const Icon = PROGRESS_STATUS_ICON[answerStatus]

  const handleToQuestion = () => {
    if (quizQuestionTemplate?.hasAnswer) {
      history.push(
        reverse(routes.quizQuestionTemplate.edit, {
          companySupplierQuestionnaireId,
          quizQuestionTemplateId: quizQuestionTemplate?.id,
        }),
      )
    } else {
      history.push(
        reverse(routes.quizQuestionTemplate.new, {
          companySupplierQuestionnaireId,
          quizQuestionTemplateId: quizQuestionTemplate?.id,
        }),
      )
    }
  }

  return (
    <Card className={classes.cardItemBoard}>
      <CardActionArea onClick={handleToQuestion}>
        <Box className={classes.cardActionArea}>
          <Box
            display="flex"
            gridGap={theme.spacing(2)}
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" color="primary">
              {quizQuestionTemplate?.theme || 'Não definido'}
            </Typography>
            <Box className={classes.containerIcon}>
              <Icon
                size={20}
                strokeWidth={2.5}
                className={classes.categoryIcon}
              />
            </Box>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  )
}

QuestionCard.propTypes = {
  companySupplierQuestionnaireId: PropTypes.string,
  quizQuestionTemplate: PropTypes.object,
}

export default QuestionCard
